import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

// Closing block for every case study: one question addressed to a reader with a
// similar problem, then the way to reach us. Keep `question` specific to the page.
const CaseStudyCta = ({ question, body, extra }) => (
  <section className="bg-paper-100 border-t border-paper-300">
    <div className="max-w-5xl mx-auto px-6 py-16 grid gap-6 md:grid-cols-[1fr_auto] md:items-end">
      <div className="max-w-2xl">
        <h2 className="font-display text-2xl md:text-3xl font-semibold text-ink tracking-tight">
          {question}
        </h2>
        {body && <p className="mt-3 text-base text-ink-muted leading-relaxed">{body}</p>}
        {extra && <div className="mt-4 text-sm">{extra}</div>}
      </div>
      <div className="flex flex-wrap gap-3">
        <Link
          to="/#contact-section"
          className="inline-flex items-center gap-2 rounded-md bg-brand-600 px-5 py-3 text-sm font-semibold text-white hover:bg-brand-700"
        >
          Talk to the team <ArrowRight size={16} aria-hidden="true" />
        </Link>
        <Link
          to="/projects"
          className="inline-flex items-center rounded-md border border-paper-300 bg-paper px-5 py-3 text-sm font-semibold text-ink hover:border-brand-600"
        >
          All projects
        </Link>
      </div>
    </div>
  </section>
);

export default CaseStudyCta;
